export enum AuthorityEnum {
  Remove = 0,
  Read = 1000,
  Write = 2000,
  Manage = 3000,
}
